import { avatarProps } from './avatar'

import type { ExtractPropTypes } from 'vue'

export const avatarGroupProps = {
  /**
   * @description control the size of avatars in this avatar-group
   */
  size: avatarProps.size,
  /**
   * @description max count of avatars to show in this avatar-group
   */
  maxCount: Number,
  /**
   * @description whether show tooltip or not
   */
  showTooltip: Boolean,
} as const
export type AvatarGroupProps = ExtractPropTypes<typeof avatarGroupProps>
